import { extractDateTimeParts } from './extract-date-time-parts';

/**
 * Format a date with name for event selectors.
 *
 * The abbreviated weekday rather than a single initial, which is what a selector needs: Catalan
 * names every day di-, so one letter gives D for all seven and the rows stop telling each other
 * apart. Abbreviated is unique across all seven locales.
 *
 * @example
 * formatDateName('My Event', 1706515200, 'Europe/Madrid', 'es')
 * // Returns: "Lun29 - My Event"
 */
export const formatDateName = (name: string, startingTime: number, timezone: string, locale: string) => {
  const parts = extractDateTimeParts(startingTime, locale, timezone);
  return `${parts.weekday}${parts.day} - ${name}`;
};
